export default {
    step: [
        {
            type: 'modal',
            buttons: {
                first: {
                    name: 'quickTour.skip',
                    action: 'skip'
                },
                second: {
                    name: 'quickTour.start',
                    action: 'next'
                }
            },
            title: `Добро пожаловать в 360 view!`,
            text: `<div class="text-center">
                                    <img src="teq-logo-icon1.svg" style="width: 36px;">
                                </div>
                                <div class="text-center">
                                    <p>Пройдите небольшой тур, это облегчит начало работы.</p>
                                </div>`
        }, {
            type: 'step',
            title: 'Задайте запросом область своего интереса',
            text: '',
            noteCoords: {
                top: 50,
                left: 0,
                right: 'auto',
                bottom: 'auto'
            },
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-PredicateEditor .predicate-block',
                    class: 'tourHighlight'
                }, {
                    selector: '.nativeSearch',
                    class: 'd-none'
                }]
            }],
        }, {
            type: 'step',
            title: 'Выберите период для анализа',
            text: '',
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-360view .filter-block .periodSelector',
                    class: 'tourHighlight'
                }]
            }],
            noteCoords: {
                top: 55,
                left: -137,
                right: 'auto',
                bottom: 'auto'
            },
        }, {
            type: 'step',
            title: 'Изучите аналитику',
            text: 'в интерактивных виджетах',
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-360view .widgets',
                    class: 'tourHighlight'
                }, {
                    selector: '.fst-360view .widgets',
                    class: 'tourSubStep0'
                }]
            }, {
                type: 'scrollTop',
                targets: [{
                    selector: '.fst-360view .widgets',
                    value: 0
                }]
            }],
            noteCoords: {
                top: "205px",
                left: "calc(50% + 155px)",
                right: 'auto',
                bottom: 'auto'
            },
            anglePlacement: 'left',
        }, {
            type: 'step',
            title: 'Взаимодействуйте с дашбордом',
            text: 'нажмите на ключевое слово, чтобы посмотреть документы с ним',
            actions: [
                {
                    type: 'addClass',
                    targets: [
                        {
                            selector: '.fst-360view .widgets',
                            class: 'tourHighlight'
                        }, {
                            selector: '.fst-360view .widgets',
                            class: 'tourSubStep1'
                        }
                    ]
                }, {
                    type: 'scrollTop',
                    targets: [
                        {
                            selector: '.fst-360view .widgets',
                            value: 0
                        }
                    ]
                }
            ],
            noteCoords: {
                top: -70,
                left: 20,
                right: 'auto',
                bottom: 'auto',
                targetElement: '.tourHighlight .cloud > div > div > div:first-child > div',
                targetCoords: true,
            },
            anglePlacement: 'left',
        }, {
            type: 'step',
            title: 'Взаимодействуйте с дашбордом',
            text: 'нажмите на компанию, чтобы открыть её карточку ',
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-360view .widgets',
                    class: 'tourHighlight'
                }, {
                    selector: '.fst-360view .widgets',
                    class: 'tourSubStep2'
                }]
            }],
            noteCoords: {
                top: -110,
                left: 'auto',
                right: -22,
                bottom: 'auto',
                targetElement: '.tourSubStep2 .cards > span:nth-child(3) .card',
                targetCoords: true,
            },
            anglePlacement: 'right',
        }, {
            type: 'step',
            title: 'Взаимодействуйте с дашбордом',
            text: 'нажмите на точку на графике, чтобы увидеть научные статьи/патенты по выбранному году',
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-360view .widgets',
                    class: 'tourHighlight'
                }, {
                    selector: '.fst-360view .widgets',
                    class: 'tourSubStep3'
                }]
            }],
            noteCoords: {
                top: -70,
                left: 20,
                right: 'auto',
                bottom: 'auto',
                targetElement: '.apexcharts-series:nth-child(2) .apexcharts-series-markers:nth-child(3) circle ',
                targetCoords: true,
            },
            anglePlacement: 'left',
        }, {
            type: 'step',
            title: 'Просматривайте документы',
            text: ' по которым была составлена аналитика',
            actions: [{
                type: 'addClass',
                targets: [{
                    selector: '.fst-360view .widget-block .header .viewAll',
                    class: 'tourHighlight'
                }]
            }, {
                type: 'scrollTop',
                targets: [{
                    selector: '.fst-360view .widgets',
                    value: 0
                }]
            }],
            noteCoords: {
                top: -50,
                left: 76,
                right: 'auto',
                bottom: 'auto'
            },
            anglePlacement: 'left',
            timeOut: 676,

        }, {
            type: 'step',
            title: 'Переключайтесь',
            text: 'между графиком и последними документами',
            actions: [
                {
                    type: 'addClass',
                    targets: [
                        {
                            selector: '.fst-360view .widgets',
                            class: 'tourStepGraphDoc'
                        }
                    ]
                }, {
                    type: 'scrollTop',
                    targets: [
                        {
                            selector: '.fst-360view .widgets',
                            value: 540
                        }
                    ]
                }
            ],
            noteCoords: {
                top: -60,
                left: 15,
                right: 'auto',
                bottom: 'auto',
                targetElement: '.tourStepGraphDoc .widget-block:nth-child(3) .widgetMode',
                targetCoords: true,
            },
            anglePlacement: 'left',
            timeOut: 686,
        }, {
            type: 'modal',
            buttons: {
                first: {
                    name: 'quickTour.again',
                    action: 'restart'
                },
                second: {
                    name: 'quickTour.finish',
                    action: 'skip'
                }
            },
            title: 'Спасибо, что прошли этот тур с нами!',
            text: `<div class="text-center">
                        <img src="teq-logo-icon1.svg" style="width: 36px;">
                    </div>
                    <div class="text-center">
                        <p>Хорошего дня!
                            <img src="smile3.png" style="width: 23px;position: relative;top: 6px;left: 3px;"><!--&#128526;--></p>
                    </div>`
        }
    ]
}